import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowDropRight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m14.77 11.808-4.458-3.715A.8.8 0 0 0 9 8.708v6.584a.8.8 0 0 0 1.312.614l4.458-3.714a.25.25 0 0 0 0-.384" })));
}
const ArrowDropRight = forwardRef(_ArrowDropRight);
export { ArrowDropRight };
